import { render, staticRenderFns } from "./ServicesInfoBanner.vue?vue&type=template&id=3c36478f"
import script from "./ServicesInfoBanner.vue?vue&type=script&lang=js"
export * from "./ServicesInfoBanner.vue?vue&type=script&lang=js"
import style0 from "./ServicesInfoBanner.vue?vue&type=style&index=0&id=3c36478f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports